import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Gift, Sparkles, Lock } from 'lucide-react';

const MembershipSection = () => {
  const benefits = [
    {
      icon: Crown,
      title: 'Early Access',
      description: 'Be the first to discover new collections and limited editions',
    },
    {
      icon: Gift,
      title: 'Exclusive Gifts',
      description: 'Receive complimentary samples and birthday surprises',
    },
    {
      icon: Sparkles,
      title: 'Private Events',
      description: 'Invitations to exclusive launches and masterclasses',
    },
    {
      icon: Lock,
      title: 'Reserved Collections',
      description: 'Access to members-only fragrances and rare editions',
    },
  ];

  return (
    <section 
      className="relative py-32 md:py-40 bg-[#050505] overflow-hidden"
      data-testid="membership-section"
    >
      <div className="absolute inset-0 arabian-pattern opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/5 via-transparent to-[#D4AF37]/5" />
      <div className="absolute inset-8 border border-[#D4AF37]/10 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Title */}
        <div className="text-center mb-16">
          <p className="font-arabic text-3xl text-[#D4AF37]/60 mb-2">النادي الحصري</p>
          <p className="font-heading text-xs tracking-[0.3em] text-[#D4AF37] mb-4">
            EXCLUSIVE MEMBERSHIP
          </p>
          <h2 
            className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-wide text-white"
            data-testid="membership-title"
          >
            THE INNER <span className="gold-shimmer">CIRCLE</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <p 
              className="font-body text-white/60 leading-relaxed mb-10 max-w-md"
              data-testid="membership-description"
            >
              Experience the world of Qasr Parfumerie like never before. As a member of 
              The Inner Circle, you'll gain exclusive access to our most coveted 
              creations, private events, and personalized fragrance consultations.
            </p>

            <Link to="/membership">
              <button
                data-testid="membership-cta-button"
                className="relative overflow-hidden bg-[#D4AF37] text-[#050505] px-12 py-5 font-heading text-sm tracking-[0.2em] hover:bg-[#E5C158] transition-colors duration-200"
              >
                REQUEST MEMBERSHIP
              </button>
            </Link>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-2 gap-6">
            {benefits.map((benefit) => (
              <div
                key={benefit.title}
                className="group p-6 md:p-8 bg-[#050505]/50 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-colors duration-200"
                data-testid={`benefit-card-${benefit.title.toLowerCase().replace(' ', '-')}`}
              >
                <div className="w-12 h-12 flex items-center justify-center border border-[#D4AF37]/30 mb-6 group-hover:bg-[#D4AF37]/10 transition-colors duration-200">
                  <benefit.icon size={24} className="text-[#D4AF37]" />
                </div>
                <h3 className="font-heading text-lg tracking-wide text-white mb-2">
                  {benefit.title}
                </h3>
                <p className="font-body text-white/50 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Quote */}
        <div className="mt-20 text-center">
          <p className="font-accent italic text-white/40 text-lg">
            "Membership is limited to ensure an intimate and exclusive experience."
          </p>
        </div>
      </div>
    </section>
  );
};

export default MembershipSection;
